/**
 * Consolidated date formatting utilities
 * Used across multiple components for consistent date/time display
 */

/**
 * Format a date value to a localized short string
 * e.g., "Mar 12, 3:45 PM"
 * @param {string|Date|null} value - Date value to format
 * @returns {string} Formatted date string or "Unknown" if invalid
 */
export const formatDateTime = (value) => {
  if (!value) return 'Unknown'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Unknown'
  return date.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/**
 * Format a date as YYYY-MM-DD for use as dictionary keys or form values
 * @param {string|Date} value - Date value to format
 * @returns {string} YYYY-MM-DD format or empty string if invalid
 */
export const formatDateKey = (value) => {
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
